import http from "../http-common";

class SchemaDataService {
  getAll() {
    return http.get("/authorui/schemas");
  }

  get(id) {
    return http.get(`/authorui/schemas/${id}`);
  }

  create(data) {
    return http.post("/authorui/schemas", data);
  }

  update(id, data) {
    return http.put(`/authorui/schemas/${id}`, data);
  }

  delete(id) {
    return http.delete(`/authorui/schemas/${id}`);
  }
}

export default new SchemaDataService();
